import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import customDataReducer from "@tecumseh/Store/Data/CustomApplicationState/CustomDataReducer";

(reducers as any).TECData = customDataReducer;

type CustomReducers = {
    TECData: typeof customDataReducer;
};

// creating custom actions along our custom reducers & OOTB actions from AnyAction
export type CustomActions = Parameters<CustomReducers[keyof CustomReducers]>[1] | AnyAction;
